import * as React from "react";
const SvgBriefcase = (props) => /* @__PURE__ */ React.createElement("svg", props, /* @__PURE__ */ React.createElement("path", { d: "M24 25a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-3H4v9c0 1.6 1.4 3 3 3h26c1.6 0 3-1.4 3-3v-9H24v3Zm9-13h-5V9c0-1.6-1.4-3-3-3H15c-1.6 0-3 1.4-3 3v3H7c-1.6 0-3 1.4-3 3v5h32v-5c0-1.6-1.4-3-3-3Zm-9 0h-8v-2h8v2Z" }));
export default SvgBriefcase;
